import {StylesConfig} from 'react-select'

/**
 * @type StylesConfig
 */
export const colourStyles = {
    container: (styles, state) => ({...styles, width: '100%'}),
    control: (styles, state) => ({...styles, padding: '0', backgroundColor: 'white', borderColor: '#CBE5FD', ":hover": {borderColor: '#69b4f9'} }),
    valueContainer: (styles) => ({...styles, padding: '.7rem .7rem .7rem'})
}